import apiClient from "../../../api/apiClient";

//Base URL

const BASE_PATH = "admin/nakshatr";

export const getNakshatrList = async () => {
  const response = await apiClient.get(`${BASE_PATH}/`, {});
  return response.data;
};

export const createNakshatr = async (createNakshatrValues) => {
  const response = await apiClient.post(BASE_PATH + "/", createNakshatrValues);
  return response.data;
};

export const getNakshatr = async () => {
  const response = await apiClient.post(`${BASE_PATH}/get`, {});
  return response.data;
};

export const updateNakshatr = async (updateNakshatrValues) => {
  const response = await apiClient.put(`${BASE_PATH}/`, updateNakshatrValues);
  return response.data;
};
